"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isIE11 = function () { return !!window.navigator.userAgent.match(/Trident.*rv\:11\./); };
//# sourceMappingURL=utils.js.map


//////////////////
// WEBPACK FOOTER
// ../player-search-module/node_modules/@csod/predictive-search/build/control/utils.js
// module id = 578
// module chunks = 0